export const logo = {
  "Twitter": "twitter_logo.png",
  "Youtube": "youtube_logo.png",
  "Mirrativ": "mirrativ_logo.png",
  "Openrec": "openrec_logo.png",
  "Niconico": "niconico_logo.png",
  "Showroom": "showroom_logo.png",
  "Instagram": "instagram_logo.png",
  "Twitch": "twitch_logo.png",
  "TikTok": "tiktok_logo.png",
  "Twitcas": "twitcas_logo.png",
  "BiliBili": "bilibili_logo.png"
}

export const grad = {
  "One": "1期生",
  "Two": "2期生",
  "Gamers": "ゲーマーズ",
  "Seeds": "SEEDs1期生",
  "Seeds2nd": "SEEDs2期生",
  "After": "統合後",
  "Voiz": "VOIZ",
  "Other": "その他"
}

export const localStrageSettings = {
  "dbname": 'nijinanji_pwa',
  "version": 1
}
